module.exports = __webpack_public_path__ + "img/travel1.d14c8161.jpg";